import { Injectable } from '@angular/core'
import {
  MaybeAsync,
  CanActivate,
  GuardResult,
  ActivatedRouteSnapshot,
} from '@angular/router'
import { GlobalService } from 'src/app/services/global/global.service'
import { StorageService } from 'src/app/services/storage/storage.service'
import { NavigationService } from 'src/app/services/navigation/navigation.service'
import { AppModule, AppModuleLabel } from 'src/app/constants/global.const'
import { AuthService } from 'src/app/services/auth/auth.service'

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private storageSvc: StorageService,
    private globalSvc: GlobalService,
    private navigationSvc: NavigationService,
    private auth: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
    return new Promise(async (resolve) => {
      const abilities = await this.storageSvc.getPermission()

      // Set module name to READ permission
      // to determine if the user has permission to access the basic module
      const accessPermission = route.data['access']

      if (accessPermission && abilities.includes(accessPermission)) {
        resolve(true)
        return
      }

      const moduleName = accessPermission?.split(':')[0]
      this.globalSvc.showToast(
        `Jika kamu merasa ini adalah kesalahan, hubungi tim mitra kami`,
        'bad',
        {
          header: `Kamu tidak memiliki akses ke modul ${AppModuleLabel[moduleName] ?? 'tersebut'}`,
        },
      )

      if (moduleName === AppModule.BUPOT_AGEN) {
        this.auth.isAuthenticated.next(false)
        resolve(false)
        return
      }

      resolve(false)
      setTimeout(() => this.navigationSvc.pop(), 300)
    })
  }
}
